import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPipLeave = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M14.3 8.25c0 .41-.34.75-.75.75h-3.49l4.55 4.55c.29.29.29.77 0 1.06a.75.75 0 0 1-1.06 0L9 10.06v3.49c0 .41-.34.75-.75.75a.76.76 0 0 1-.75-.75v-5.3c0-.1.02-.2.06-.29a.63.63 0 0 1 .16-.24.73.73 0 0 1 .53-.22h5.3c.41 0 .75.34.75.75Z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 22h9v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-1V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2ZM24 6.5H7a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h9V17a1 1 0 0 1 1-1h7.5V7a.5.5 0 0 0-.5-.5Z"
	})]
});
export { SvgPipLeave as ReactComponent };
